module.exports = __webpack_public_path__ + "img/16.eebd1618.jpg";